<template>
  <div class="Application">
    <section-header heading="2" ja="アプリ版「プリクラON」の紹介"/>
    <div class="textArea">
      <p>
        アプリ版「プリクラON」だとこんな機能も使えるよ！<br>
        ・らくがき/背景/メイクのON/OFF<br>
        ・リップ/チーク/カラーライナーの編集<br>
        ・ARプリクラ<br>
        ・特別なプリクラ「プリもっと」
      </p>
      <p>
        アプリは以下のリンクからダウンロードしてね♪
      </p>
    </div>
    <div class="storeLink">
      <a
        class="ios"
        href="https://apps.apple.com/jp/app/%E3%83%97%E3%83%AA%E3%82%AF%E3%83%A9on/id1491707486?l=en&amp;itsct=apps_box&amp;itscg=30200">
        <img
          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-JP?size=250x83&amp;releaseDate=1601942400&h=fd01c540f4b59e9b14385d0f0471c6f8"
          alt="Download on the App Store">
      </a>
      <a
        class="android"
        href='https://play.google.com/store/apps/details?id=com.sega.puri&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
        <img
          alt='Google Play で手に入れよう'
          src='https://play.google.com/intl/en_us/badges/static/images/badges/ja_badge_web_generic.png' />
      </a>
    </div>
    <sub-btn @click="onHome()">戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import MaintenanceCheck from '../mixins/maintenancecheck';
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "Application",
  components: {
    SectionHeader,
    SubBtn
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
  },
  mixins: [Protobuf,MaintenanceCheck],
  methods: {
    onHowToUse() {
      this.$router.push("/Tutorial")
    },
    onFAQ() {
      this.$router.push("/faq")
    },
    onContact() {
      window.open(process.env.VUE_APP_CONTACT_US_URL, "_blank")
    },
    onHome() {
      if(sessionStorage.getItem('prevPage')) {
        this.$router.push(sessionStorage.getItem('prevPage'))
      } else {
        this.$router.push('/')
      }
    },
  },
  mounted(){
    this.maintenanceCheck();
  },
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
.storeLink {
  margin: 10px 0;
  text-align: center;
  .ios {
    display: inline-block;
    overflow: hidden;
    border-radius: 13px;
    width: 160px;
    height: 71px;
    padding: 11px;
    vertical-align: top;
    & > img {
      border-radius: 13px;
      width: 140px;
      height: 49px;
    }
  }
  .android {
    & > img { height: 70px; }
  }
}
</style>
